export const COLUMN_VISIBILITY_CHANGE = 'change:tableColumnVisibility';
export const COLUMN_ORDER_CHANGE = 'change:tableColumnOrder';
export const PIVOT_CHANGE = 'change:pivot';
export const TABLE_TYPE_CHANGE = 'change:tableType';
export const TABLE_CONFIG_RESET = 'change:tableConfigReset';
